import { render, staticRenderFns } from "./SubmissionLockedAlert.vue?vue&type=template&id=2fb93ac7&scoped=true&"
import script from "./SubmissionLockedAlert.vue?vue&type=script&lang=js&"
export * from "./SubmissionLockedAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb93ac7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
